import BaseModelFactory from './base.factory'
import UserEmailHistoryService from '../services/UserEmailHistory.service'
import UserEmailHistory from '../models/user-email-history.model'

class UserEmailHistoryFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UserEmailHistoryService, Model: UserEmailHistory }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: UserEmailHistoryService, Model: UserEmailHistory })
  static findAllByUserId = async id =>
    await this._findAllBy({ user_id: id }, { Service: UserEmailHistoryService, Model: UserEmailHistory })
  static create = payload =>
    this._create(payload, {
      Service: UserEmailHistoryService,
      Model: UserEmailHistory,
    })
}

export default UserEmailHistoryFactory
